import FavoritesItemProvider from '../src/components/FavoritesItemProvider/FavoritesItemProvider';

export default FavoritesItemProvider;
